import { cn } from '~/shared/lib/cn';
import { Button } from '~/shared/ui/button';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '~/shared/ui/hover-card';

import { useLogin } from '../lib';

export function LoginButton() {
  const { handleLogin } = useLogin();

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button>Log In</Button>
      </HoverCardTrigger>
      <HoverCardContent className={cn('w-56 bg-background')}>
        <div className="flex w-40 flex-col rounded-l-lg bg-background">
          <Button
            variant="ghost"
            justify="start"
            onClick={() => handleLogin({ role: 'admin' })}
          >
            As an administrator
          </Button>
          <Button
            variant="ghost"
            justify="start"
            onClick={() => handleLogin({ role: 'teacher' })}
          >
            As a teacher
          </Button>
          <Button
            variant="ghost"
            justify="start"
            onClick={() => handleLogin({ role: 'student' })}
          >
            As a student
          </Button>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
  // return (
  //   <DropdownMenu>
  //     <DropdownMenuTrigger asChild>
  //       <Button>Log In</Button>
  //     </DropdownMenuTrigger>
  //     <DropdownMenuContent>
  //       <DropdownMenuItem onClick={(event) => event.preventDefault()}>
  //         <Button
  //           variant="ghost"
  //           size="small"
  //           width="full"
  //           justify="start"
  //           onClick={() => handleLogin({ role: 'admin' })}
  //         >
  //           As an administrator
  //         </Button>
  //       </DropdownMenuItem>
  //       <DropdownMenuItem onClick={(event) => event.preventDefault()}>
  //         <Button
  //           variant="ghost"
  //           size="small"
  //           width="full"
  //           justify="start"
  //           onClick={() => handleLogin({ role: 'user' })}
  //         >
  //           As a user
  //         </Button>
  //       </DropdownMenuItem>
  //     </DropdownMenuContent>
  //   </DropdownMenu>
  // );
}
